import React from "react";
import { FaBuilding } from "react-icons/fa";

interface Investment {
  companyName: string;
  industry: string;
  ebitda: string;
  investmentDate: string;
}

interface MAOpportunitiesData {
  name: string;
   similarlySizedCompetitors: number;
  largerCompetitors: number;
  smallerCompetitors: number;
  investments: Investment[];
}

interface MAOpportunitiesProps {
  partner?: MAOpportunitiesData;
tenantId?: string;
  tenantServiceId?: string;
  tenantServiceOptionId?: string;
}


// MOCK DATA
const mockPartnerData: MAOpportunitiesData = {
  name: "Merger & Acquistion Opportunities",
  similarlySizedCompetitors: 24,
  largerCompetitors: 8,
  smallerCompetitors: 24,

  investments: [
    {
      companyName: "United Interactive",
      industry: "Healthcare",
      ebitda: "$4.5 Mn",
      investmentDate: "June 2025",
    },
    {
      companyName: "Acme Tech",
      industry: "Software",
      ebitda: "$6.2 Mn",
      investmentDate: "May 2025",
    },
    {
      companyName: "EcoFarm Foods",
      industry: "Agriculture",
      ebitda: "$2.1 Mn",
      investmentDate: "April 2025",
    },
    {
      companyName: "Clear Logistics",
      industry: "Logistics",
      ebitda: "$5.3 Mn",
      investmentDate: "March 2025",
    },
    {
      companyName: "NextGen Motors",
      industry: "Automotive",
      ebitda: "$8.9 Mn",
      investmentDate: "February 2025",
    },
    {
      companyName: "Skyline Construction",
      industry: "Infrastructure",
      ebitda: "$4.8 Mn",
      investmentDate: "January 2025",
    },
    {
      companyName: "UrbanConnect",
      industry: "Telecom",
      ebitda: "$3.7 Mn",
      investmentDate: "December 2024",
    },
    {
      companyName: "MediTrust",
      industry: "Healthcare",
      ebitda: "$7.0 Mn",
      investmentDate: "November 2024",
    },
    {
      companyName: "FinSecure",
      industry: "Finance",
      ebitda: "$6.4 Mn",
      investmentDate: "October 2024",
    },
    {
      companyName: "BrightEdu",
      industry: "EdTech",
      ebitda: "$2.9 Mn",
      investmentDate: "September 2024",
    },
  ],
};

const MAOpportunities: React.FC<MAOpportunitiesProps> = ({
    partner=mockPartnerData,
  tenantId,
  tenantServiceId,
  tenantServiceOptionId,
}) =>{

    console.log(tenantId,tenantServiceId,tenantServiceOptionId," MAOpportunities ")
  return (
    <div className="bg-white rounded-3xl shadow border border-gray-200 p-0 max-w-4xl mx-auto mt-0 2xl:mt-20  ">
      {/* Header */}
      <div className="flex items-start gap-4 px-6 py-6  bg-[#FAFBFD] border border-gray-200">
        <div className="flex-1">
          <h1 className="text-2xl font-light  text-gray-900 ">{partner.name}</h1>

          <div className="flex items-center font-light justify-between mt-2">
            <div>
              <p className="text-gray-400 ">Similarly Sized Competitors</p>
              <p>{partner.similarlySizedCompetitors}</p>
            </div>
            <div>
              <p className="text-gray-400">Larger Competitors</p>
              <p>{partner.largerCompetitors}</p>
            </div>
            <div>
              <p className="text-gray-400">Smaller Competitors</p>
              <p>{partner.smallerCompetitors}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="flex flex-wrap gap-2 px-6 py-4  ">
        <button className="px-4 py-1.5 text-sm rounded-full bg-gray-50 border border-gray-200 text-[#1A73E8]  cursor-pointer">
          Bestfit
        </button>
        <button className="px-4 py-1.5 text-sm rounded-full bg-[#F1F3F4] text-gray-700 border border-gray-200  cursor-pointer">
          Larger competitors
        </button>
        <button className="px-4 py-1.5 text-sm rounded-full bg-[#F1F3F4] text-gray-700 border border-gray-200  cursor-pointer">
          Smaller competitors
        </button>
      </div>

      {/* Investment List - Scrollable */}
      <div className="  max-h-[400px] overflow-y-auto">
        {partner.investments.map((inv, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between px-6 py-4 border-b border-gray-200 hover:bg-gray-50"
          >
            {/* Company & Icon */}
            <div className="flex items-center gap-3 min-w-[200px]">
              <div className="w-5 h-5 rounded-full bg-gradient-to-br from-indigo-500 to-blue-500 text-white flex items-center justify-center text-xs">
                <FaBuilding className="text-white text-sm" />
              </div>
              <div className="text-sm text-gray-900 font-medium">
                {inv.companyName}
              </div>
            </div>

            {/* Industry */}
            <div className="text-sm text-blue-700 min-w-[100px]">
              {inv.industry}
            </div>

            {/* EBITDA */}
            <div className="text-sm text-gray-700 min-w-[120px]">
              EBIDTA {inv.ebitda}
            </div>

            {/* Date */}
            <div className="text-sm text-gray-700 min-w-[100px]">
              {inv.investmentDate}
            </div>

            {/* More */}
            <button className="text-sm text-[#1A73E8] ">More</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MAOpportunities;
